import useObjectTypeProperties from 'flow-doctor-lib/hooks/useObjectTypeProperties';
import useReferenceOptions from 'flow-doctor-lib/hooks/useReferenceOptions';
import useHubSpotDefinedEventProperties from 'flow-doctor-lib/hooks/useHubSpotDefinedEventProperties';
import { isHubSpotDefinedEvent } from 'flow-doctor-lib/utils/objectUtils';
const usePropertiesWithOptions = ({
  portalId,
  propertyName,
  objectTypeId,
  rawOptions
}, {
  skipOptions
} = {}) => {
  const {
    data: objectPropertyMap,
    loading: objectPropertyMapLoading,
    error: objectPropertyMapError
  } = useObjectTypeProperties({
    portalId,
    objectTypeId
  }, {
    skip: isHubSpotDefinedEvent(objectTypeId)
  });
  const {
    data: eventPropertyMap,
    loading: eventPropertyMapLoading,
    error: eventPropertyMapError
  } = useHubSpotDefinedEventProperties({
    portalId,
    objectTypeId
  }, {
    skip: !isHubSpotDefinedEvent(objectTypeId)
  });
  const propertyWrapper = objectPropertyMap || eventPropertyMap ? (objectPropertyMap || eventPropertyMap)[propertyName] : undefined;
  const labelsForOptions = useReferenceOptions({
    portalId,
    propertyWrapper,
    rawOptions
  }, {
    skip: skipOptions || !propertyWrapper
  });
  return {
    propertyWrapper,
    labelsForOptions,
    loading: objectPropertyMapLoading || eventPropertyMapLoading,
    error: objectPropertyMapError || eventPropertyMapError
  };
};
export default usePropertiesWithOptions;